<form name="form" (ngSubmit)="f.form.valid && personalsubmit()" #f="ngForm" novalidate>
  <div id="top" class="wrapper    {{formClass}}">
    <div class="modal-header">
      <!-- <h2 class="sub-header-text">Personal Preferences</h2> -->
    </div>
    <div class="modal-body">
    <h2 class="sub-header-text txt-mobile">What Areas of Study Are You Interested In?</h2>
      <div class="search-contents" [hidden]='loading'>
        <div class="col-sm-12 col-md-12">
            <div class="loader-wrapper">
            <div class="loader-img">
            </div>
            <h5>Please wait!</h5>
            <p>We are loading content for you...</p>
            </div>
        </div>
      </div>
      <div class="row mx-0">
          <div *ngFor='let bucket of bucketlist' [ngClass]="{'selected': getSelectedBucket(bucket.id)}" class="area-study" (click)="primarySelected(bucket.id,bucket.title)">
           <span class="icon {{ bucket.icon_name }} " ></span>
            <h5 class="subject-text pbucket">{{ bucket.title }}</h5>
          </div>
      </div>

      <div class="error-display" *ngIf="errdisplay ">
        <ul class="p-0">
          <li *ngFor='let msg of errormsg' class="errorclass">{{ msg }}</li>
        </ul>
      </div>
    </div>
    <div class=" m-footer modal-footer flex-column">
    <div class="d-flex justify-content-between w-100" >
      <a href="javascript:void(0)" (click)="prevAction()" role="button" class="btn  btn-prev btn-sm">
        <i class="fas fa-arrow-left pr-2"></i>Prev
      </a>
      <div class="slider-scroll">
        <ul>
          <li class="d-inline"><i class="far fa-circle"></i></li>
          <li class="d-inline"><i class="fas fa-circle"></i></li>
          <li class="d-inline"><i class="far fa-circle"></i></li>
          <li class="d-inline"><i class="far fa-circle"></i></li>
          <li class="d-inline"><i class="far fa-circle"></i></li>
        </ul>
      </div>
  
      
      <a href="javascript:void(0)" (click)="clickSubmit(f.form.valid)" class="btn btn-next btn-sm">
        NEXT<i class="fas fa-arrow-right pl-2"></i>
      </a>
   
    </div>

      <div id="footer" class="text-center mt-3">
        <p>© {{ _parent.year }} CollegeRecon. All rights reserved.</p>
     </div>
    </div>

  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/personal/personal.component.html